import BaseApi from '../BaseApi';
import { SlotsHistoryConverter } from './SlotsHistoryConverter';

// import { MOCK } from './mock';

class SlotsHistoryApi extends BaseApi {
  converter;
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/mini_admin`;
    this.converter = new SlotsHistoryConverter();
  }

  getSlotsHistory = filterData =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/bet_history`, filterData, undefined, data =>
      this.converter.convertSlotsHistory(data),
    );
}

export default SlotsHistoryApi;
